import React from "react";
import "./css/Immersive.css";

function Immersivetext() {
  return (
    <div className="immersve-cont">
      <div class="section-content">
        <h2 class="eyebrow-section">Audio performance</h2>
        <h3 class="headline-section">
          H2.&nbsp;More <br />
          immersive by <br class="medium" />
          every measure.
        </h3>
        <p class="intro-copy large-10 small-12">
          <h2>
            {" "}
            The new Apple‑designed H2 chip is the force behind AirPods Pro and
            its advanced audio performance. It works in concert with a
            custom‑built driver and amplifier to deliver crisp, clear high notes
            and deep, rich bass in stunning definition — so every sound is more
            vivid than&nbsp;ever.
          </h2>
        </p>
      </div>
    </div>
  );
}

export default Immersivetext;
